module.exports = __webpack_public_path__ + "img/40800.66cad711.jpg";